import { IonContent } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { AppHeader } from "../../../components/Header/AppHeader";
import user from "../../../services/users/reducer";
import AddEditEntryEating from "./AddEditEntryEating";
import AddEditEntryToilet from "./AddEditEntryToilet";

export interface RouteParams {
	id: string;
	dateTS: string;
	eid: string;
	type: string;
}

interface props {
	users: any;
	currentUser: any;
}

const Entry: React.FC<props> = ({ users, currentUser }) => {
	let { id, dateTS, eid, type } = useParams<RouteParams>();

	const [user, setUser] = useState<any>([]);

	useEffect(() => {
		if (users) {
			if (currentUser.isAdmin) {
				setUser(users[id]);
			} else {
				setUser(currentUser);
			}
		}
	}, [users]);

	return (
		<>
			<AppHeader title={"Entry"} />
			<IonContent fullscreen className="ion-padding">
				{user.study === "eat" && (
					<AddEditEntryEating user={user} eid={eid} dateTS={dateTS} />
				)}
				{user.study === "toilet" && (
					<AddEditEntryToilet
						user={user}
						eid={eid}
						dateTS={dateTS}
						type={type}
					/>
				)}
			</IonContent>
		</>
	);
};

const mapStateToProps = (state: any) => ({
	users: state.user.users,
	currentUser: state.user.userDetails,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Entry);
